import { produce } from "immer";

export function cloneWithRedactedPasswordProperties(objectWithPotentiallySensitiveProperties: unknown) {
    const redact = (current: unknown) => {
        if(current === null || typeof current !== "object") {
            return;
        }

        for(const propName of Object.getOwnPropertyNames(current)) {
            const propKey = propName as keyof typeof current;
            if(typeof current[propKey] === "object") {
                redact(current[propKey]);
            } else if(typeof current[propKey] === "string" && propName.toLocaleLowerCase().includes("password")) {
                (current as { [propKey]: string })[propKey] = "** redacted **";
                console.log("Redacted sensitive data in request.");
            }
        }
    };

    return produce(objectWithPotentiallySensitiveProperties, draft => { redact(draft); });
}
